import {createSelector} from "reselect";

const dashboards = (state) => state.dashboard;

export const getDashboardTableData = createSelector(
  dashboards,
  (dashboards) => dashboards.dashboard_list
);
